<template>
  <div>
    <router-view />
    <ScrollTopProgress />
    <!-- Global confirm modal instance bound to composable state -->
    <ConfirmModal
      v-model="showConfirm"
      type="delete"
      :title="confirmTitle"
      :message="confirmMessage"
      :confirm-text="confirmConfirmText"
      :cancel-text="confirmCancelText"
      @confirm="() => handleConfirm(true)"
      @cancel="() => handleConfirm(false)"
    />
    <AlertModal
      v-model="alertModel"
      :message="alertState.message"
      :type="alertState.type"
      :title="alertState.title"
      :type-label="alertState.typeLabel"
      :link="alertState.link"
      :alertcode="alertState.alertcode"
    />
    <LicenseAccessWarningModal v-model="showLicenseWarning" @renew="renewLicense" />
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ConfirmModal from './components/UiCompunents/ConfirmModal.vue';
import AlertModal from './components/Common/AlertModal.vue';
import LicenseAccessWarningModal from './components/Common/LicenseAccessWarningModal.vue';
import ScrollTopProgress from './components/Common/ScrollTopProgress.vue';
import { useConfirm } from './stores/composables.js';
import { useAlertModal } from './stores/alertModal.js';
import { useUserAreaStore } from './stores/common/userArea.js';
import apiClient from './axios';
const { showConfirm, confirmMessage, confirmTitle, confirmConfirmText, confirmCancelText, onConfirm } = useConfirm()
const { alertState, closeAlert } = useAlertModal()
const route = useRoute();
const router = useRouter();
const userAreaStore = useUserAreaStore();
const showLicenseWarning = ref(false);
const licenseCheckInProgress = ref(false);
const licenseCheckedForToken = ref('');

const alertModel = computed({
  get: () => alertState.show,
  set: (value) => {
    if (!value) closeAlert()
  },
})

function handleConfirm(val) {
  onConfirm(val)
}

async function checkCompanyLicense() {
  const token = localStorage.getItem('token');
  if (!token) {
    licenseCheckedForToken.value = '';
    showLicenseWarning.value = false;
    return;
  }
  if (licenseCheckedForToken.value === token || licenseCheckInProgress.value) return;

  licenseCheckInProgress.value = true;
  try {
    const { data } = await apiClient.get('/License/CompanyLicenseInfo');
    const licenseInfo = data?.licenseInfo ?? data?.LicenseInfo ?? data?.result ?? data?.Result ?? data?.data ?? data;
    const rawHasAccess = licenseInfo?.hasAccess ?? licenseInfo?.HasAccess ?? licenseInfo?.has_access;
    const hasAccess = rawHasAccess === false || rawHasAccess === 0 || String(rawHasAccess).toLowerCase() === 'false'
      ? false
      : rawHasAccess === true || rawHasAccess === 1 || String(rawHasAccess).toLowerCase() === 'true'
        ? true
        : null;
    console.debug('Company license access status:', hasAccess);
    showLicenseWarning.value = hasAccess === false;
    licenseCheckedForToken.value = token;
  } catch (error) {
    console.warn('Company license status could not be checked:', error);
  } finally {
    licenseCheckInProgress.value = false;
  }
}

function renewLicense() {
  userAreaStore.renewLicense();
  if (route.path !== '/overview/common/user-area') router.push('/overview/common/user-area');
}

onMounted(checkCompanyLicense);
watch(() => route.fullPath, checkCompanyLicense);
</script>
<style></style>
